// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3luU9","content":"styles_content__3rmAt"};